var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Effect")]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "animation_selector" }
              },
              [_vm._v("\n            Effect Selector\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.objectDbHash,
                      expression: "activeEffect.objectDbHash"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "animation_selector" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.activeEffect,
                          "objectDbHash",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function($event) {
                        return _vm.changeSelectedEffect(_vm.event)
                      }
                    ]
                  }
                },
                _vm._l(_vm.effects, function(effectSelector, key) {
                  return _c(
                    "option",
                    {
                      key: key,
                      staticClass: "custom-select",
                      domProps: { value: key }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(effectSelector.name) +
                          "\n              "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "animation_selector" }
              },
              [_vm._v("\n            Effect Type\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.effectType,
                      expression: "activeEffect.effectType"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "animation_selector" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.activeEffect,
                        "effectType",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "2D" } }, [_vm._v(" 2D ")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3D" } }, [_vm._v(" 3D ")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "start_time" }
              },
              [_vm._v("\n            Start Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.activeEffect.startTime,
                    expression: "activeEffect.startTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "start_time" },
                domProps: { value: _vm.activeEffect.startTime },
                on: {
                  change: function($event) {
                    return _vm.changeDuration()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.activeEffect, "startTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "end_time" }
              },
              [_vm._v("\n            End Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.activeEffect.endTime,
                    expression: "activeEffect.endTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "end_time" },
                domProps: { value: _vm.activeEffect.endTime },
                on: {
                  change: function($event) {
                    return _vm.changeDuration()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.activeEffect, "endTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "presentation_duration" }
              },
              [_vm._v("\n            Presence Duration\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                staticClass: "form-control",
                class: {
                  "border-danger":
                    (
                      parseFloat(_vm.activeEffect.endTime) -
                      parseFloat(_vm.activeEffect.startTime)
                    ).toFixed(2) <= 0
                },
                attrs: {
                  type: "number",
                  readonly: "",
                  id: "presentation_duration"
                },
                domProps: {
                  value: (
                    parseFloat(_vm.activeEffect.endTime) -
                    parseFloat(_vm.activeEffect.startTime)
                  ).toFixed(2)
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n            Loop\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("div", { staticClass: "input-switch label-right p-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeEffect.loop,
                        expression: "activeEffect.loop"
                      }
                    ],
                    attrs: { type: "checkbox", id: "loop" },
                    domProps: {
                      checked: Array.isArray(_vm.activeEffect.loop)
                        ? _vm._i(_vm.activeEffect.loop, null) > -1
                        : _vm.activeEffect.loop
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.activeEffect.loop,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.activeEffect,
                                "loop",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.activeEffect,
                                "loop",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.activeEffect, "loop", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n            Position of the Origin \n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.position[0],
                      expression: "activeEffect.position[0]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "position_of_the_origin_x" },
                  domProps: { value: _vm.activeEffect.position[0] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.position,
                        0,
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.position[1],
                      expression: "activeEffect.position[1]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "position_of_the_origin_y" },
                  domProps: { value: _vm.activeEffect.position[1] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.position,
                        1,
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.position[2],
                      expression: "activeEffect.position[2]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "position_of_the_origin_z" },
                  domProps: { value: _vm.activeEffect.position[2] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.position,
                        2,
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n            Rotation of the Origin\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.rotation[0],
                      expression: "activeEffect.rotation[0]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "rotation_of_the_origin_x" },
                  domProps: { value: _vm.activeEffect.rotation[0] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.rotation,
                        0,
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.rotation[1],
                      expression: "activeEffect.rotation[1]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "rotation_of_the_origin_y" },
                  domProps: { value: _vm.activeEffect.rotation[1] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.rotation,
                        1,
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeEffect.rotation[2],
                      expression: "activeEffect.rotation[2]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "rotation_of_the_origin_z" },
                  domProps: { value: _vm.activeEffect.rotation[2] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeEffect.rotation,
                        2,
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n            Scale (in meters)\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeEffect.scale,
                        expression: "activeEffect.scale"
                      }
                    ],
                    attrs: { type: "range", min: "0", max: "1", step: "0.1" },
                    domProps: { value: _vm.activeEffect.scale },
                    on: {
                      __r: function($event) {
                        return _vm.$set(
                          _vm.activeEffect,
                          "scale",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "col-4" }, [
                  _vm._v(_vm._s(_vm.activeEffect.scale))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-left", attrs: { for: "loop" } }, [
      _c("span")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b4e0a40", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4e0a40","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/effects/maininspector.vue
// module id = null
// module chunks = 